import * as Tooltip from '@radix-ui/react-tooltip'

import ApolloProvider from '@/components/Apollo'
import { Suspense } from '@/components/ui/Suspense'
import CookieBanner from '@/components/CookieBanner'
import { AuthProvider } from '@/features/auth'
import { ToastProvider } from '@/features/toast'
import { Provider as I18nProvider } from '@/features/i18n'

import { useFileSubscription } from '@/features/files'
import { useFeedbacksSubscriptions } from '@/features/feedback'
import { useOrdersSubscriptions } from '@/features/order'
import { useFeatureSubscription } from './features/integrations'

import Router from './Router'

function Container() {
  useFileSubscription()
  useFeedbacksSubscriptions()
  useOrdersSubscriptions()
  useFeatureSubscription()

  return <Router />
}

const Root: React.FC = function () {
  return (
    <div className="h-screen w-screen bg-background overflow-hidden">
      <ApolloProvider>
        <I18nProvider>
          <Suspense isFullPage>
            <AuthProvider>
              <CookieBanner />
              <Tooltip.Provider>
                <ToastProvider>
                  <Container />
                </ToastProvider>
              </Tooltip.Provider>
            </AuthProvider>
          </Suspense>
        </I18nProvider>
      </ApolloProvider>
    </div>
  )
}

export default Root
